import { Drawer, Grid } from 'antd';
import { FiX } from 'react-icons/fi';
import { getMenu } from '../../Layout.constants.ts';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/icons/logo.svg';
import { usePermissions } from '../../../../hooks/usePermissions.ts';
import { useQuery } from '@tanstack/react-query';
import { fetchEmail } from '../../../../pages/dashboard/Dashboard.services.ts';

const { useBreakpoint } = Grid;

const MobileMenu = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const screens = useBreakpoint();
  const { data: email } = useQuery({
    queryKey: ['email'],
    queryFn: fetchEmail,
    retry: false,
  });
  const { isAdmin } = usePermissions(0);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const menu = isAdmin ? getMenu({ email }) : getMenu({ email }).filter((item) => item.key !== 5);
  return (
    <>
      <Drawer
        title={<img src={logo} alt="logo" />}
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
        width={screens.xs ? '100%' : 365}
        extra={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FiX fontSize={24} onClick={onClose} color="var(--primary-color)" />
          </div>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 48 }}>
          {menu.map((item) => (
            <Link key={item.name} to={item.path}>
              <div className="menu-item">{item.name}</div>
            </Link>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default MobileMenu;